<app-view-title Title="{{ 'Intellitrailer.Booking.ChooseSpecificTrailer.Title' | translate : 'Choose Specific Trailer' }}" mode="split"></app-view-title>
<view-content [centered]="true" [nopadding]="true">
  @if(loading) {
  <div class="spinner-container">
    <mat-spinner diameter="70"></mat-spinner>
    <p>{{'Interllitrailer.SelectFamily.txtLoadingTrailers' | translate: 'Loading available trailers...'}}</p>
  </div>
  }
  @else
  {
  @if(rentalObjects) {
  @if(selectedObject) {
  <div class="m-4">
    <title-with-divider>{{ 'Intellitrailer.Booking.Component.ChooseSpecificTrailer.SelectedTrailer' | translate : 'Selected trailer' }}</title-with-divider>
    <data-list>
      <list-item>
        <img src="{{ selectedObject.Image }}" />
        <div>
          <h2>{{ selectedObject.Title }} @if(selectedObject.Alias){<span>- {{selectedObject.Alias}}</span>}</h2>
          <ng-container *ngFor="let item of selectedObject.Type.Attributes; let i = index">
            <small>
              {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate }}
            </small>
            @if((i + 1) % 3 === 0){ <br> }
          </ng-container>
        </div>
      </list-item>
    </data-list>
  </div>
  }
  @if(availableObjects?.length > 0) {
  <div class="m-4">
    <title-with-divider>{{ 'Intellitrailer.Booking.Component.ChooseSpecificTrailer.AvailableTrailers' | translate : 'Available trailers' }}</title-with-divider>
    <data-list>
      <list-item *ngFor="let obj of availableObjects" (click)="selectAvailableObject(obj)">
        <img src="{{ obj.Image }}" />
        <div>
          <h2>{{ obj.Title }} @if(obj.Alias){<span>- {{obj.Alias}}</span>}</h2>
          <ng-container *ngFor="let item of obj.Type.Attributes; let i = index">
            <small>
              {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate }}
            </small>
            @if((i + 1) % 3 === 0){ <br> }

          </ng-container>
        </div>
      </list-item>
    </data-list>
  </div>
  }
  @else {
  <p>{{'Intellitrailer.Booking.Component.ChooseSpecificTrailer.msgNoAvailableTrailers' | translate : 'No other trailers are available'}}</p>
  }
  @if(unAvailableObjects?.length > 0 || reservedObjects?.length > 0) {
  <div class="m-4">
    <title-with-divider>{{ 'Intellitrailer.Booking.Component.ChooseSpecificTrailer.UnavailableTrailers' | translate : 'Unavailable trailers' }}</title-with-divider>
    <data-list>
      <list-item *ngFor="let obj of reservedObjects" class="unavailable">
        <div class="unavailableMessage"> <mat-icon>lock</mat-icon> {{'Intellitrailer.Booking.Component.ChooseSpecificTrailer.msgReserved' | translate : 'Reserved' }}</div>
        <img src="{{ obj.Image }}" />
        <div>
          <h2>{{ obj.Title }} @if(obj.Alias){<span>- {{obj.Alias}}</span>}</h2>
          <ng-container *ngFor="let item of obj.Type.Attributes; let i = index">
            <small>
              {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate }}
            </small>
            @if((i + 1) % 3 === 0){ <br> }
          </ng-container>
        </div>
      </list-item>
      <list-item *ngFor="let obj of unAvailableObjects" class="unavailable">
        <div class="unavailableMessage"><mat-icon>block</mat-icon>{{'Intellitrailer.Booking.Component.ChooseSpecificTrailer.msgDisabled' | translate : 'Disabled' }}</div>
        <img src="{{ obj.Image }}" />
        <div>
          <h2>{{ obj.Title }} @if(obj.Alias){<span>- {{obj.Alias}}</span>}</h2>
          <ng-container *ngFor="let item of obj.Type.Attributes; let i = index">
            <small>
              {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate }}
            </small>
            @if((i + 1) % 3 === 0){ <br> }
          </ng-container>
        </div>

      </list-item>
    </data-list>
  </div>
  }
  }
  }
</view-content>
